import { Controller } from "@hotwired/stimulus";

// Turbo replaces the whole pinned panel after every Mo turn, which would snap a <details> the user
// opened back to collapsed. Remembers the open state per key for the tab's lifetime.
export default class extends Controller {
  static values = { key: String };

  connect() {
    const remembered = this.read();
    if (remembered !== null) {
      this.element.open = remembered === "open";
    }
    this.onToggle = () => this.write(this.element.open ? "open" : "closed");
    this.element.addEventListener("toggle", this.onToggle);
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.onToggle);
  }

  read() {
    try {
      return window.sessionStorage.getItem(this.storageKey);
    } catch {
      return null;
    }
  }

  write(state) {
    try {
      window.sessionStorage.setItem(this.storageKey, state);
    } catch {
      // Storage can be unavailable (private mode, blocked); the panel then just renders as sent.
    }
  }

  get storageKey() {
    return `details-memory:${this.keyValue}`;
  }
}
